import { useEffect, useState, useRef, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { BsQuestionCircle } from "react-icons/bs";
import SucessModal from "../../../../components/SucessModal/Sucess";
import WarningModal from "../../../../components/Warning/Warning";
import Loader from "../../../../components/Loader/Loader";
import Grid, { GridColumn, GridHeader, GridRow } from "../../../../components/Grid/Grid";
import { NavLink } from "react-router-dom";
import WebService from "../../../../utility/WebService";
import { useParams } from "react-router-dom";
import HelperService from "../../../../utility/HelperService";
import BackComponent from "../../../../components/BackArrow";
import { Controller, useForm } from "react-hook-form";
import CustomDatePicker from "../../../../components/DatePicker/CustomDatePicker";
import CustomDropdown from "../../../../components/Select/CustomDropdown";
import loader from "../../../../assets/images/button-loader.svg";
import { Label } from "../../../../components/Label/Label";
import MultiSelect, { Options } from "../../../../components/MultiSelect/MultiSelect";




const headers: GridHeader[] = [
    {
        title: "Date",
        classTitle: 'text-start'
    },
    {
        title: "Day",
        class: 'text-center'
    },
    {
        title: "Branch",
        class: 'text-center'
    },
    {
        title: "Occasion",
        class: 'text-center'
    },
    {
        title: "Actions",
        class: "text-center"
    },



];

const AddComplaints = () => {
    const {
        register,
        handleSubmit,
        reset,
        control,
        setValue,
        watch,
        formState: { errors },
    } = useForm();
    const watchAllFields = watch();
    const [showLoader, setShowLoader] = useState(false);
    const [warningMessage, setWarningMessage] = useState<any>()
    const [isShowWarningModal, setShowWarningModal] = useState(false);
    const [sucessMessage, setSucessMessage] = useState<any>()
    const [isShowSucessModal, setShowSucessModal] = useState(false);
    const [rows, setRows] = useState<GridRow[]>([]);
    const [totalCount, setTotalCount] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [activationDate, setActivationDate] = useState(null);
    const [holidayDate, setHolidayDate] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [monthValue, setMonthValue] = useState<any>();
    const [yearValue, setYearValue] = useState<any[]>([]);
    const [yearOption, setYearOption] = useState<any[]>([]);
    const [receivedDate, setReceivedDate] = useState<any>();
    const [statusDate, setStatusDate] = useState<any>();

    let history = useNavigate();
    let { id } = useParams();
    useEffect(() => {
        if (id) {
            getDetail();
        }

        getYearOption();
    }, []);


    const onSave = (data: any) => {

        setLoading(true);
        if (id) {
            console.log(data);
            WebService.putAPI({
                action: `/v2/Complaints/Update?id=${id}`,
                body: data,
            })
                .then((res: any) => {
                    //setLoading(false);
                    setShowSucessModal(true);
                    setSucessMessage(res.message)
                    goBack();
                })
                .catch((e) => {
                    setShowWarningModal(true);
                    setWarningMessage(e.response.data.message);
                    setLoading(false);
                });
        } else {
            WebService.postAPI({
                action: `/v2/Complaints/Create`,
                body: data,
            })
                .then((res: any) => {
                    setShowSucessModal(true);
                    setSucessMessage(res.message)
                    setLoading(false);
                    goBack();

                })
                .catch((e) => {
                    setShowWarningModal(true);
                    //setWarningMessage(e.response.data.message)
                    setLoading(false);
                });
        }


    };
    const getDetail = () => {
        setShowLoader(true)
        WebService.postAPI({
            action: `/v2/Complaints/GetDetail?id=${id}`,
        })
            .then((res: any) => {
                reset(res.result)
                setShowLoader(false)
                setMonthValue(res.result?.month);
                setYearValue(res.result.year);
                setReceivedDate(res.result?.received_date)
                setStatusDate(res.result?.status_date)
            })
            .catch((e) => {
                setShowLoader(false)
                setShowWarningModal(true);
                setWarningMessage(e.response.data.message)
            });
    }

    const MonthsOption: Options[] = [
        { id: "4", value: "April", code: "" },
        { id: "5", value: "May", code: "" },
        { id: "6", value: "June", code: "" },
        { id: "7", value: "July", code: "" },
        { id: "8", value: "August", code: "" },
        { id: "9", value: "September", code: "" },
        { id: "10", value: "October", code: "" },
        { id: "11", value: "November", code: "" },
        { id: "12", value: "December", code: "" },
        { id: "1", value: "January", code: "" },
        { id: "2", value: "February", code: "" },
        { id: "3", value: "March", code: "" },
    ];
    const getYearOption = () => {
        setShowLoader(true);
        WebService.postAPI({
            action: '/v2/Complaints/GetYearList',
            body: null
        })
            .then((res: any) => {
                var array: any = [];
                for (var i in res.list) {
                    array.push({ id: res.list[i], value: res.list[i] });
                }
                setYearOption(array);
                setShowLoader(false);
            })
            .catch((e) => {
                setShowLoader(false);

            })
    }

    const goBack = () => {
        window.history.back();
    };

    const warningCloseModal = () => {
        setShowWarningModal(false)
        setShowLoader(false);
    }

    const sucessCloseModal = () => {
        setShowSucessModal(false)
        setShowLoader(false);
    }
    
    return (
        <>
            <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            />
            <WarningModal
                show={isShowWarningModal}
                isClose={warningCloseModal}
                message={warningMessage}
            />
            <Loader show={showLoader} />
            <div className="page-content-wraper">
                <div className="grid grid-cols-2 gap-4 mb-3">
                    <div>
                        {" "}
                        <BackComponent
                            title={id ? "Edit Complaints" : "Add Complaints"}
                        />
                    </div>
                </div>
                <form onSubmit={handleSubmit(onSave)}>
                    <div className="rounded-xl bg-white p-4 mb-4">
                        <div className=" grid grid-cols-3 gap-4 form-style">
                            <div className="mb-2">
                                <label className="label">
                                    Month<span className=" text-red-600">*</span>
                                </label>
                                <Controller
                                    control={control}
                                    name="month"
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <CustomDropdown
                                            isSearchable={true}
                                            options={MonthsOption}
                                            selected={monthValue}
                                            onChange={(data: any) => {
                                                field.onChange(data.id);
                                                setMonthValue(data.id);
                                            }}
                                        />

                                    )}
                                />
                                <div>
                                    {errors.month && (
                                        <Label
                                            title={"Please Select Month."}
                                            modeError={true}
                                        />
                                    )}
                                </div>
                            </div>

                            <div className="mb-2">
                                <label className="label">
                                    Year<span className=" text-red-600">*</span>
                                </label>
                                <Controller
                                    control={control}
                                    name="year"
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <CustomDropdown
                                            isSearchable={true}
                                            options={yearOption}
                                            selected={yearValue}
                                            onChange={(data: any) => {
                                                field.onChange(data.id);
                                                setYearValue(data.id);
                                            }}
                                        />
                                    )}
                                />
                                <div>
                                    {errors.year && (
                                        <Label
                                            title={"Please Select Year ."}
                                            modeError={true}
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="flex mt-2">
                                <label className="label">
                                    Is Complaint Regestired ?<span className=" text-red-600">*</span>
                                </label>
                                <div className="flex items-center mr-4">
                                    <input
                                        id="1"
                                        type="radio"
                                        value={'Yes'}
                                        className="custom-radio"
                                        {...register("is_complaint_regestired", {
                                            required: true,
                                        })}
                                    />
                                    <label htmlFor="1" className="block text-sm font-medium text-gray-700">Yes</label>
                                </div>
                                <div className="flex items-center">
                                    <input
                                        id="2"
                                        type="radio"
                                        value={'No'}
                                        className="custom-radio"
                                        {...register("is_complaint_regestired", {
                                            required: true,
                                        })}
                                    />
                                    <label htmlFor="2" className="ml-3 block text-sm font-medium text-gray-700">No</label>
                                </div>
                            </div>

                        </div>
                    </div>
                    {watchAllFields.is_complaint_regestired == 'Yes' &&
                        <div className="rounded-xl bg-white p-4 mb-4">
                            <div className=" grid grid-cols-2 gap-4 form-style">
                                <div className="mb-2">
                                    <label className="label">
                                        Received From
                                        <span className=" text-red-600">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=" "
                                        {...register("received_from", {
                                            required: true,
                                        })}
                                    />
                                    <div>
                                        {errors.received_from && (
                                            <Label
                                                title={"Please Enter Received From."}
                                                modeError={true}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="mb-2">
                                    <label className="label">
                                        Received Date<span className=" text-red-600">*</span>
                                    </label>
                                    <Controller
                                        control={control}
                                        name="received_date"
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <CustomDatePicker
                                                selected={receivedDate}
                                                onChange={(data: any) => {
                                                    field.onChange(data);
                                                    //setReceivedDate(data);

                                                }}
                                            />

                                        )}
                                    />
                                    <div>
                                        {errors.received_date && (
                                            <Label
                                                title={"Please Select Recommendation Date."}
                                                modeError={true}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="mb-2">
                                    <label className="label">
                                        Status Date<span className=" text-red-600">*</span>
                                    </label>
                                    <Controller
                                        control={control}
                                        name="status_date"
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <CustomDatePicker
                                                selected={statusDate}
                                                onChange={(data: any) => {
                                                    field.onChange(data);
                                                }}
                                            />

                                        )}
                                    />
                                    <div>
                                        {errors.status_date && (
                                            <Label
                                                title={"Please Select Recommendation Date."}
                                                modeError={true}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="mb-2">
                                    <label className="label">
                                        Complaint ID
                                        <span className=" text-red-600">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=" "
                                        {...register("complaint_id", {
                                            required: true,
                                        })}
                                    />
                                    <div>
                                        {errors.complaint_id && (
                                            <Label
                                                title={"Please Enter complaint id."}
                                                modeError={true}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="flex md-4">
                                    <label className="label">
                                        Status<span className=" text-red-600">*</span><br></br><br></br><br></br><br></br><br></br>
                                    </label>
                                    <div className="flex items-center">
                                        <input
                                            id="3"
                                            type="radio"
                                            value={'Resolved'}
                                            className="custom-radio"
                                            {...register("status", {
                                                required: true,
                                            })}
                                        />
                                        <label htmlFor="3" className="block text-sm font-medium text-gray-700">Resolved</label>
                                    </div>
                                    <div className="flex items-center">
                                        <input
                                            id="4"
                                            type="radio"
                                            value={'Open with Investor'}
                                            className="custom-radio"
                                            {...register("status", {
                                                required: true,
                                            })}
                                        />
                                        <label htmlFor="4" className="ml-3 block text-sm font-medium text-gray-700">Open with Investor</label>
                                    </div>
                                    <div className="flex items-center">
                                        <input
                                            id="5"
                                            type="radio"
                                            value={'Open with SEBI'}
                                            className="custom-radio"
                                            {...register("status", {
                                                required: true,
                                            })}
                                        />
                                        <label htmlFor="5" className="ml-3 block text-sm font-medium text-gray-700">Open with SEBI</label>
                                    </div>
                                    <div className="flex items-center">
                                        <input
                                            id="6"
                                            type="radio"
                                            value={'Open with Advisor'}
                                            className="custom-radio"
                                            {...register("status", {
                                                required: true,
                                            })}
                                        />
                                        <label htmlFor="6" className="ml-3 block text-sm font-medium text-gray-700">Open with Advisor</label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    }
                    <div className="text-center mt-4">
                        <button
                            type="button"
                            className="btn btn-white mr-3"
                            onClick={goBack}
                        >
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-brand">
                            {isLoading && <img src={loader} className="spinner" />}Save
                        </button>
                    </div>
                </form >
            </div >
        </>
    );
};
export default AddComplaints;

